import React, { useContext, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/joy";
import { useNavigate } from 'react-router-dom';
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { AppContext } from "src/mtska-frontend-app-scaffolding";
import { useTranslation } from "react-i18next";

const Auth0LoginButton = ({ className, label = "Login" }) => {

    const { error, getAccessTokenWithPopup } = useAuth0();

    const { t } = useTranslation(); 
    const navigate = useNavigate();

    const { loadOne: loadConfig } = useDataProvider('configs/config')
    const { item, loadOne } = useDataProvider('auth/token')

    const { setUser, setUserCapabilities, userCapabilities, appConfiguration, loginError, setLoginError, setLoginOptions } = useContext(AppContext)

    useEffect(() => {
        if (typeof item?.token === 'undefined') return;
        localStorage.setItem('token', item?.token)
    }, [item, navigate])

    const login = () => {
        (async () => {
            try {
                const token = await getAccessTokenWithPopup({
                    authorizationParams: {
                        audience: appConfiguration.auth0.AUDIENCE
                    }
                })
                if (token !== null) {
                    localStorage.setItem('token', token)

                    loadOne(token).then((response) => { //+"?role=_reset"
                        if (response?.item?.data?.errorMessage) {
                            setLoginError(response?.item?.data?.errorMessage);
                        } else if (response?.item?.data?.options) {
                            setLoginOptions(response?.item?.data?.options);
                        } else {
                            setLoginError(null);
                            setLoginOptions(null);
                            setUser(response?.item?.data);

                            loadConfig(token).then((response) => {
                                if (response && response.item && response.item.data) {
                                    setUserCapabilities(response.item.data.capabilities);
                                }
                            });
                        }
                    });
                }
            } catch (e) {
                switch (e) {
                    case 'Error: Your password has expired. Please reset it.':
                        setLoginError(e);
                        break;
                    default:
                        break;
                }
            }
        })()
    }

    // DUBITO CHE QUESTA VENGA MAI USATA
    useEffect(() => {
        if (Object.keys(userCapabilities).lenght > 0) {
            console.info('Save me, AUTH0LOGINBUTTON')
            navigate(
                process.env.REACT_APP_AUTH0_DEFAULT_AUTHENTICATED_URI ||
                appConfiguration.auth0.DEFAULT_AUTHENTICATED_URI,
                { replace: true }
            );
        }
    }, [userCapabilities])


    return <>
        {error && error.messages}
        <Button
            size="regular"
            variant="solid"
            className={className}
            onClick={login}
        >
            {t(label)}
        </Button>
    </>
}

export default Auth0LoginButton;